
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"a","xmlns":"http://www.w3.org/2000/svg","version":"1.1","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.4,7.1h.4c2.3,0,4.5.9,6.1,2.6h0c0,0,0,.1,0,.1,1.7,1.6,2.6,3.9,2.6,6.2h0v.2c0,2.3-.9,4.6-2.6,6.2h0c0,0,0,.1,0,.1-1.6,1.6-3.8,2.6-6.1,2.6h-.3c-2.3,0-4.6-.9-6.2-2.6l-.5-.5c-1.4-1.6-2.2-3.7-2.2-5.8h0c0-2.5.9-4.7,2.6-6.4h0c0,0,0-.1,0-.1,1.6-1.6,3.8-2.6,6.1-2.6M19,36.7h.2c0,0,2.5,1.7,2.5,1.7h0c0,0,0,.1,0,.1,1.4.8,2.9,1.5,4.4,2,1.8.6,3.8.9,5.7.9s3.9-.3,5.7-.9c1.5-.5,3-1.1,4.4-2h0c0,0,0-.1,0-.1l2.5-1.6h0c.5,0,1,.1,1.5.3h0c.6.2,1.1.5,1.5.9.5.5,1,1.1,1.4,1.8.5.8.8,1.6,1.1,2.6.3,1,.6,2.1.8,3.2.2,1.1.3,2.2.4,3.3,0,1.1.1,2.2.1,3.2v.2c0,1.2-.4,2.4-1.2,3.3-.9.8-2.1,1.3-3.4,1.3h-29.9s-.1,0-.1,0h-.3c-1.3,0-2.5-.5-3.4-1.3-.8-.9-1.3-2.1-1.3-3.3h0v-.2c0-1.1,0-2.1,0-3h0c0,0,0-.2,0-.2,0-1.1.2-2.2.4-3.3.2-1.1.5-2.1.8-3.1.3-.9.7-1.7,1.1-2.5h0c0,0,0-.1,0-.1.4-.7.8-1.3,1.3-1.8.5-.4,1-.7,1.6-1,.5-.2,1-.3,1.5-.4M31.4,1.3c-3.9,0-7.6,1.6-10.3,4.3-2.8,2.7-4.4,6.5-4.3,10.4,0,3.9,1.5,7.7,4.3,10.4h0c2.7,2.8,6.4,4.3,10.3,4.3h.3c3.9,0,7.6-1.6,10.3-4.3,2.8-2.7,4.4-6.5,4.3-10.4,0-3.9-1.5-7.7-4.3-10.4-2.7-2.8-6.4-4.3-10.3-4.3h-.4ZM19.8,30.9c-1.5,0-2.9.3-4.3.8-1.3.5-2.5,1.2-3.5,2.2-1,.9-1.8,2-2.4,3.2-.7,1.2-1.2,2.4-1.6,3.6-.4,1.3-.7,2.6-1,3.9-.2,1.3-.4,2.5-.5,3.8-.1,1.2-.1,2.4-.1,3.6-.1,2.9,1,5.6,3,7.7,2,1.9,4.7,2.9,7.4,2.9h29.9c.1,0,.3,0,.4,0,2.7,0,5.4-1,7.4-2.9,2-2,3.1-4.8,3-7.7,0-1.2,0-2.5-.1-3.6,0-1.3-.3-2.6-.5-3.9-.2-1.3-.6-2.6-1-3.9-.4-1.3-.9-2.5-1.6-3.7-.6-1.2-1.5-2.2-2.4-3.2-1-.9-2.2-1.7-3.5-2.1-1.4-.5-2.8-.8-4.3-.8h0c-.9.1-1.7.5-2.4,1l-2.5,1.6c-1,.6-2.1,1.1-3.2,1.4-1.3.4-2.6.6-4,.6s-2.7-.2-4-.6c-1.1-.3-2.2-.8-3.2-1.4l-2.5-1.6c-.7-.6-1.5-1-2.4-1.1h-.1Z"}})])
          )
        }
      }
    